import { render, staticRenderFns } from "./JourneyQuizItem.vue?vue&type=template&id=48107fe1&scoped=true&"
import script from "./JourneyQuizItem.vue?vue&type=script&lang=js&"
export * from "./JourneyQuizItem.vue?vue&type=script&lang=js&"
import style0 from "./JourneyQuizItem.vue?vue&type=style&index=0&id=48107fe1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48107fe1",
  null
  
)

/* custom blocks */
import block0 from "./JourneyQuizItem.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports